import { itemApi } from "@api/items";
import { sendErrorNotification } from "@components/Notifications";
import {
  IS_LOADING,
  SUCCESS,
  HAS_ERROR,
  QUERY_STRING_UPDATE,
  CLEAR_SEARCH,
} from "./types";

export const fetchAndCheckoutIfOne = (barcode, patronPid, onSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const response = await itemApi.list(
        itemApi.query().withBarcode(barcode).qs()
      );

      dispatch({
        type: SUCCESS,
        payload: response.data,
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      dispatch({
        type: HAS_ERROR,
        payload: error,
      });
      dispatch(sendErrorNotification(error));
    }
  };
};

export const updateQueryString = (queryString) => {
  return (dispatch) => {
    dispatch({
      type: QUERY_STRING_UPDATE,
      queryString: queryString,
    });
  };
};

export const clearResults = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_SEARCH,
    });
  };
};
